import { style, animate, transition, trigger } from '@angular/animations';

export const fadeOut: any = trigger('fadeOut', [transition(':leave', [animate(200, style({ opacity: 0 }))])]);
